import {Route, Routes, useLocation} from "react-router-dom";
import {Paths} from "../sidebar/Paths";
import {FooterComponent} from "../footer/FooterComponent";
import React, {useEffect, useRef} from "react";
import './content.css'

export default function ContentComponent() {
    const location = useLocation();
    const routes = buildRoutes();
    const scrollContainer = useRef(null)

    useEffect(() => {
        if (scrollContainer.current) {
            scrollContainer.current.scrollTop = 0
        }
    }, [location]);

    return (<div className="contentWrapper" ref={scrollContainer}>
        <div className="content fullHeight">
            <Routes>
                {routes}
            </Routes>
        </div>
        <FooterComponent/>
    </div>);
}

function buildRoutes() {
    const topLevelNavKeys = Object.keys(Paths)
    const routesArray = [];

    for (const key of topLevelNavKeys) {
        const navObject = Paths[key];
        if (navObject.nested.length !== 0) {
            const nestedKeys = Object.keys(navObject.nested)
            for (const nestedKey of nestedKeys) {
                const nestedNavObject = navObject.nested[nestedKey];
                const screen = nestedNavObject.screen;
                if (!screen) continue;
                routesArray.push(<Route key={nestedNavObject.path}
                                        path={nestedNavObject.path}
                                        element={screen()}/>);
            }
        } else {
            const screen = navObject.screen
            if (!screen) continue;
            routesArray.push(<Route key={navObject.path} path={navObject.path} element={screen()}/>);
        }
    }
    return routesArray;
}